import React from "react";
import { isLanguageEnglish } from "../Common/utils";
import AuthorizedSignatoryNameField from "./AuthorizedSignatoryNameField";

const AuthorizedSignatoryNameFields = ({ t, language, fullName, submit, authErrors, handleNameChange }) => {
  const getError = (name, id) =>
    authErrors[name] ? t(`newuser.${id}error`) : submit && !fullName[name] ? t(`newuser.${id}requiredApprover`) : "";

  return isLanguageEnglish(language) ? (
    <>
      <AuthorizedSignatoryNameField name="fName" id="fn" t={t} fullName={fullName} onNameChange={handleNameChange} getError={getError} />
      <AuthorizedSignatoryNameField name="lName" id="ln" t={t} fullName={fullName} onNameChange={handleNameChange} getError={getError} />
    </>
  ) : (
    <>
      <AuthorizedSignatoryNameField name="lName" id="ln" t={t} fullName={fullName} onNameChange={handleNameChange} getError={getError} />
      <AuthorizedSignatoryNameField name="fName" id="fn" t={t} fullName={fullName} onNameChange={handleNameChange} getError={getError} />
    </>
  );
};

export default AuthorizedSignatoryNameFields;
